export default __webpack_public_path__ + "static/media/savannah.61a9c897.png";